import React from 'react';
import { Card } from 'reactstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { gql } from 'apollo-boost';
import ProductLotsCard from './productLotsCard';
import NextLotTransfer from '~/components/nextLotTransfer/nextLotTransfer';
import UserFullname from '~/components/userFullname/userFullname';

export const getProductCurrentLotsQuery = gql`
  query product($id: Int!) {
    product(id: $id) {
      id
      currentLots {
        id
        volume
        reference
        startDate
        startedByUser {
          id
          firstName
          lastName
        }
        currentTank {
          id
          name
        }
        nextTransfer {
          id
          type
          tankType
          vesselDescription
          location {
            id
            name
          }
          tank {
            id
            name
          }
        }
      }
    }
  }
`;

const CompletedLots = ({ lots }) => (
  <Card>
    {lots.map(lot => {
      const { id, volume, reference, currentTank, startDate, nextTransfer, startedByUser } = lot;

      return (
        <div key={id} className="bb-divider pa3 flex">
          <div className="flex-grow-1">
            <p className="f5">
              <Link to={`/lots/${id}`}>{reference}</Link>
            </p>
            {currentTank && (
              <p>
                Currently in tank
                <Link to={`/tanks/${currentTank.id}`}> {currentTank.name}</Link>
              </p>
            )}
            <p>
              Started on {moment(startDate).format('dddd Do MMMM')} by <UserFullname user={startedByUser} />
            </p>
            <NextLotTransfer nextTransfer={nextTransfer} />
          </div>
          <div>
            <p>Volume: {volume}L</p>
          </div>
        </div>
      );
    })}
  </Card>
);

const ProductCompletedLotsCard = props => (
  <ProductLotsCard
    {...props}
    query={getProductCurrentLotsQuery}
    queryKey="currentLots"
    render={CompletedLots}
    title="Current lots
"
  />
);

export default ProductCompletedLotsCard;



// WEBPACK FOOTER //
// ./src/containers/productLotsCard/current.jsx